import React from 'react';
import styles from './CampoNumero.module.css';
import stylesTexto from './CampoTexto.module.css';
import 'cleave.js/dist/addons/cleave-phone.br';
import Cleave from 'cleave.js/react';

type CampoNumeroProps = {
  label?: string;
  /** '' limpa o campo — o Cleave ignora `undefined` e mantém o texto anterior. */
  value?: number | '';
  placeholder?: string;
  onChange?: (value: number) => void;
  props?: any;
  mostrarSeparadorMilhar?: boolean;
  decimais?: number;
  somentePositivos?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
  prepend?: React.ReactNode;
  append?: React.ReactNode;
  noBorder?: boolean;
};

const CampoNumero = ({
  label,
  value,
  placeholder,
  onChange,
  mostrarSeparadorMilhar,
  decimais,
  somentePositivos,
  disabled,
  error,
  hint,
  prepend,
  append,
  noBorder,
  ...props
}: CampoNumeroProps) => {
  return (
    <div className={styles.container}>
      {label && <label className={stylesTexto.label}>{label}</label>}
      <div
        className={[
          stylesTexto.container,
          error ? stylesTexto.error : null,
        ].join(' ')}
        style={{ border: noBorder ? 'none' : undefined }}
      >
        {prepend && <div className={stylesTexto.prepend}>{prepend}</div>}

        <Cleave
          {...props}
          type="tel"
          value={value}
          // guide={false}
          options={{
            numeral: true,
            numeralThousandsGroupStyle: mostrarSeparadorMilhar
              ? 'thousand'
              : 'none',
            numeralDecimalScale: decimais ?? 0,
            numeralDecimalMark: ',',
            delimiter: '.',
            numeralPositiveOnly: somentePositivos,
          }}
          onChange={e => onChange && onChange(e.target.rawValue)}
          className={stylesTexto.input}
          style={{ border: noBorder ? 'none' : undefined }}
          disabled={disabled}
          placeholder={placeholder}
        />

        {append && <div className={stylesTexto.append}>{append}</div>}
      </div>
      {hint && !error && <div className={stylesTexto.hint}>{hint}</div>}
      {error && <div className={stylesTexto.error}>{error}</div>}
    </div>
  );
};

export default CampoNumero;
